import React from 'react';
import {Badge, IconButton, Tooltip} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import API from '@beardeddevops/react.api';
import Types from 'constants/Types';

export default class SignupNotifications extends React.Component {
	state = {count: null, unavailable: false};

	componentDidMount() {
		this.active = true;
		this.refresh();
		this.timer = window.setInterval(this.refresh, 30000);
		window.addEventListener('signup-notifications-changed', this.refresh);
	}

	componentWillUnmount() {
		this.active = false;
		window.clearInterval(this.timer);
		window.removeEventListener('signup-notifications-changed', this.refresh);
	}

	refresh = async () => {
		if (this.refreshing) return;
		this.refreshing = true;
		try {
			const model = new API.BuildClass(Types.Admins_Accounts._name, API.RequestType.READ_ALL);
			model.limit = 1;
			const response = await model.submit(null, API.RequestType.READ_ALL, true);
			if (!model.successful || !response || typeof response.unread_signup_count === 'undefined') throw new Error('Signup count unavailable');
			if (this.active) this.setState({count: Number(response.unread_signup_count), unavailable: false});
		} catch (error) {
			if (this.active) this.setState({unavailable: true});
		} finally {
			this.refreshing = false;
		}
	};

	render() {
		const {count, unavailable} = this.state;
		const label = unavailable ? 'Signup notifications unavailable' : (count === null ? 'Loading signup notifications' : `${count} new customer signups`);
		return (
			<Tooltip title={label}>
				<IconButton aria-label={label} onClick={() => this.props.history.push('/account_activity')} className="header-btn">
					<Badge badgeContent={unavailable ? '!' : count} color="secondary" max={999}>
						<NotificationsIcon/>
					</Badge>
				</IconButton>
			</Tooltip>
		);
	}
}
